module.exports = __webpack_public_path__ + "static/img/41746686306_.pic.48e8f75.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/41746686306_.pic.png
// module id = RS+0
// module chunks = 11